import { USER_ROLE } from 'src/types';
import { analytics } from '../analytics';
import { REPORT_TRANSLATION_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

export interface TrackReportTranslationProps {
  organisation_id: number;
  user_id: number;
  case_id: string;
  report_id: string;
  user_role: USER_ROLE;
  source: string;
  permissions: string[];
  new_translation: string;
  old_translation: string;
  reported_category: string;
  determined_category: string;
  intake_method: string;
}

export const trackReportTranslationEvent = (
  properties: TrackReportTranslationProps,
) => {
  return analytics.track(
    REPORT_TRANSLATION_EVENT_IDS.REPORT_TRANSLATED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};
